import React, { useState, useEffect } from "react";
import "./VTHome.css";
import VTInsulation from "./VTInsulation";
import VTChecking from "./VTChecking";
import VTRatio from "./VTRatio";
import VTList from "./VTList";
import CreateReport from "./CreateReport";
import { API_URL } from "./API";

const VTHome = ({ project, goBack }) => {
  const windings = ["1a - 1n", "2a - 2n", "3a - 3n", "4a - 4n", "da - dn"];
  const kneePointTypes = [
    "0.1", "0.2", "0.5", "0.2S", "0.5S", "0.1S", "0.3",
    "5P10", "5P20", "10P10", "P5", "PX", "PR", "TPX", "TPY", "TPZ"
  ];

  const [selectedWinding, setSelectedWinding] = useState("");
  const [windingDetails, setWindingDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState("home");
  const [showBackPage, setShowBackPage] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const initialFormData = {
    general: {
      description: "VT INSPECTION / TEST REPORT", date: "", customer: "", project: "", reportNo: "",
      location: "", client: "", yom: "", il: "", vf: "", frequency: "",
      type: "", specNo: "", insulationClass: "",  make: "", serialNo: ""
    },
    winding: "",
    windingDetails: [],
    insulationData: [],
    windingResistance: [],
    polarityCheck: [],
    ratioTestData: {},
    checklistData: []
  };

  const [allFormData, setAllFormData] = useState(initialFormData);

 
  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
    return "Unknown Client";
  };

  const getWindingCount = (winding) => {
    if (winding.startsWith("da")) {
      return 5;
    } else {
      const match = winding.match(/^(\d)/);
      return match ? parseInt(match[1]) : 0;
    }
  };


  useEffect(() => {
  const savedData = localStorage.getItem('vtFormData');
  if (savedData) {
    try {
      const parsedData = JSON.parse(savedData);
      
      // Check if there's any meaningful user-entered data
      // Exclude read-only fields from the check
      const userEditableFields = ['date', 'customer', 'reportNo', 'location', 
                                   'yom', 'il', 'vf', 'frequency', 'type', 
                                   'specNo', 'insulationClass', 'make', 'serialNo'];
      
      const hasUserData = parsedData.general && 
                         userEditableFields.some(key => parsedData.general[key]);
      
      if (parsedData && hasUserData) {
        setAllFormData(parsedData);
        
        if (parsedData.winding) {
          setSelectedWinding(parsedData.winding);
          
          const expectedCount = getWindingCount(parsedData.winding);
          if (parsedData.windingDetails && parsedData.windingDetails.length === expectedCount) {
            setWindingDetails(parsedData.windingDetails);
          } else {
            const newDetails = Array.from({ length: expectedCount }, (_, index) => {
              return parsedData.windingDetails && parsedData.windingDetails[index] 
                ? parsedData.windingDetails[index]
                : { ratio: "", vaPh: "", class: "", volts: "" };
            });
            setWindingDetails(newDetails);
            setAllFormData(prev => ({
              ...prev,
              windingDetails: newDetails
            }));
          }
        }
      }
      // Don't remove localStorage if no user data - let it persist
      
    } catch (error) {
      console.error('Error parsing saved form data:', error);
      localStorage.removeItem('vtFormData');
    }
  }
}, []);

// useEffect(() => {
//   const savedData = localStorage.getItem('vtFormData');
//   if (savedData) {
//     try {
//       const parsedData = JSON.parse(savedData);
      
//       if (parsedData && Object.keys(parsedData.general || {}).some(key => parsedData.general[key])) {
//         setAllFormData(parsedData);
        
//         if (parsedData.winding) {
//           setSelectedWinding(parsedData.winding);
          
//           const expectedCount = getWindingCount(parsedData.winding);
//           if (parsedData.windingDetails && parsedData.windingDetails.length === expectedCount) {
//             setWindingDetails(parsedData.windingDetails);
//           } else {
//             const newDetails = Array.from({ length: expectedCount }, (_, index) => {
//               return parsedData.windingDetails && parsedData.windingDetails[index] 
//                 ? parsedData.windingDetails[index]
//                 : { ratio: "", vaPh: "", class: "", volts: "" };
//             });
//             setWindingDetails(newDetails);
//             setAllFormData(prev => ({
//               ...prev,
//               windingDetails: newDetails
//             }));
//           }
//         }
//       } else {
       
//         localStorage.removeItem('vtFormData');
//       }
//     } catch (error) {
//       console.error('Error parsing saved form data:', error);
//       localStorage.removeItem('vtFormData');
//     }
//   }
// }, []);

  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setAllFormData(prev => ({
          ...prev,
          general: {
            ...prev.general,
            project: project?.name || '',
            client: clientName || ''
          }
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

  useEffect(() => {
    localStorage.setItem('vtFormData', JSON.stringify(allFormData));
  }, [allFormData]);

  useEffect(() => {
    if (selectedWinding && selectedWinding !== allFormData.winding) {
      const count = getWindingCount(selectedWinding);
      
      const newDetails = Array.from({ length: count }, (_, index) => {
        return windingDetails[index] || { ratio: "", vaPh: "", class: "", volts: "" };
      });

      setWindingDetails(newDetails);

      setAllFormData(prev => ({
        ...prev,
        winding: selectedWinding,
        windingDetails: newDetails
      }));
    }
  }, [selectedWinding]);




useEffect(() => {
 
  const shouldReset = localStorage.getItem('resetVTForm');
  if (shouldReset === 'true') {
    setSelectedWinding("");
    setWindingDetails([]);
    setAllFormData(initialFormData);
    localStorage.removeItem('resetVTForm');
  }
}, []);

  const resetWindingSelection = () => {
  setSelectedWinding("");
  setWindingDetails([]);
};


const clearAllFormData = () => {
  setAllFormData(initialFormData);
  setSelectedWinding("");
  setWindingDetails([]);
 
  localStorage.removeItem('vtFormData');
};

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    let newVal = value;
    let error = "";

    if (["description", "type", "insulationClass"].includes(name)) {
      if (!/^[a-zA-Z\/\ ]*$/.test(value)) {
        error = "Only alphabetic characters are allowed";
        newVal = allFormData.general[name];
      }
    } else if (["customer", "client"].includes(name)) {
      if (!/^[a-zA-Z\s]*$/.test(value)) {
        error = "Only alphabetic characters are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "project") {
      if (!/^[a-zA-Z0-9\s, ]*$/.test(value)) {
        error = "Only alphabetic and numeric characters are allowed";
        newVal = allFormData.general[name];
      }
    } else if (["reportNo", "location"].includes(name)) {
      if (!/^[a-zA-Z0-9\s-,]*$/.test(value)) {
        error = "Only alphabetic characters, numbers, and '-' are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "il") {
      if (!/^[a-zA-Z0-9\s/]*$/.test(value)) {
        error = "Only alphabetic characters, numbers, and '/' are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "vf") {
      if (!/^[a-zA-Z0-9\s.&]*$/.test(value)) {
        error = "Only alphabetic characters, numbers, float values, and '&' are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "specNo") {
      if (!/^[a-zA-Z0-9\s:-\s/&]*$/.test(value)) {
        error = "Only alphabetic characters, numbers, and ':' are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "make") {
      if (!/^[a-zA-Z\s0-9]*$/.test(value)) {
        error = "Only alphabetic characters are allowed";
        newVal = allFormData.general[name];
      }
    } else if (name === "yom") {
      const currentYear = new Date().getFullYear();
    
        if (!/^\d{0,4}$/.test(value)) {
          error = "Only 4 digit year is allowed";
          newVal = allFormData.general[name];
        } else if (parseInt(value, 10) > currentYear) {
          error = `Year cannot be greater than ${currentYear}`;
          newVal = allFormData.general[name];
          alert("Year cannot be greater than the current year");
        }
    
    } else if (name === "serialNo") {
      if (!/^[0-9/s, ]*$/.test(value)) {
        error = "Only numbers and '/' are allowed";
        newVal = allFormData.general[name];
      }
    }

    if (error) {
      setErrorMsg(error);
      setTimeout(() => setErrorMsg(""), 3000);
    }

    setAllFormData(prev => ({
      ...prev,
      general: { ...prev.general, [name]: newVal }
    }));
  };

  const handleDetailChange = (index, key, value) => {
    const updated = [...windingDetails];
    let newVal = value;
    let error = "";

    if (["ratio", "volts"].includes(key)) {
      if (!/^[a-zA-Z0-9./√ ]*$/.test(value)) {
        error = "Only numbers and '/' are allowed";
        newVal = updated[index][key];
      }
    } else if (key === "vaPh") {
      if (!/^[a-zA-Z0-9\s ]*$/.test(value)) {
        error = "Only numbers and Alphabets are allowed";
        newVal = updated[index][key];
      }
    }

    if (error) {
      setErrorMsg(error);
      setTimeout(() => setErrorMsg(""), 3000);
    }

    updated[index][key] = newVal;
    setWindingDetails(updated);

    setAllFormData(prev => ({
      ...prev,
      windingDetails: updated
    }));
  };

  const handleNext = () => setCurrentPage("insulation");
  
  const handleBackword = () => {
    if (window.confirm("Are you sure you want to reload? All unsaved data will be lost.")) {
      window.location.reload();
    }
  }

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};
  const handleBack = () => {
    const pages = ["home", "insulation", "checking", "ratio", "checklist"];
    const idx = pages.indexOf(currentPage);
    setCurrentPage(pages[Math.max(0, idx - 1)]);
  };

  const updateFormData = (section, data) => {
    setAllFormData(prev => ({ ...prev, [section]: data }));
  };
  
  const renderHomePage = () => (
    <div className="vt-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 className="vt-head">VOLTAGE INSPECTION / TEST REPORT</h2>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          
          <span 
            style={{ 
              display: 'flex',
              justifyContent: 'flex-end',
              fontSize: '20px', 
              fontWeight: '600', 
              color: '#333', 
              cursor: 'pointer',
              marginLeft: '10px'
            }}
            onClick={redirectToHome}
          >
            X
          </span>
        </div>
      </div>
      
      {errorMsg && <div className="error-msg">{errorMsg}</div>}<br/>

      <div className="grid">
        {["description", "date", "customer", "project", "reportNo", "location", "client"].map(field => (
          <label key={field}>
            {field.charAt(0).toUpperCase() + field.slice(1)}
            <input
              name={field}
              type={field === "date" ? "date" : "text"}
              value={allFormData.general[field]}
              maxLength={40}
              onChange={handleFormChange}
              placeholder={`Enter ${field}`}
              readOnly={["description", "project", "client"].includes(field)}
              style={["description", "project", "client"].includes(field) ? {
               
                cursor: 'not-allowed',
                
              } : {}}
            />
          </label>
        ))}
      </div>

      <h3 className="vt-head1">NAME PLATE DETAILS  </h3><br/>
      <div className="grid">
        {[
          { name: "yom", label: "YOM (Year of Manufacturing)" },
          { name: "il", label: "IL (Insulation Level)" },
          { name: "vf" },
          { name: "frequency" },
          { name: "type" },
          { name: "specNo" },
          { name: "insulationClass", label: "Insulation Class" },
          { name: "make" },
          { name: "serialNo", label: "Serial No" }
        ].map(({ name, label }) => (
          <label key={name}>
            {(label || name.toUpperCase())}
            {name === "frequency" ? (
              <select name={name} value={allFormData.general[name]} onChange={handleFormChange}>
                <option value="">Select Frequency</option>
                <option value="50HZ">50HZ</option>
                <option value="60HZ">60HZ</option>
              </select>
            ) : (
              <input
                name={name}
                value={allFormData.general[name]}
                maxLength={40}
                onChange={handleFormChange}
                placeholder={`Enter ${label || name}`}
              />
            )}
          </label>
        ))}
      </div>

      <label>No of Windings:
        <select value={selectedWinding} onChange={(e) => setSelectedWinding(e.target.value)}>
          <option value="">Select Winding</option>
          {windings.map(w => <option key={w} value={w}>{w}</option>)}
        </select>
      </label>

      {windingDetails.map((detail, idx) => (
        <fieldset key={idx} className="winding-section">
          <legend><h4>Winding {idx + 1} Details</h4></legend>

          <label>Ratio
            <input
              type="text"
              value={detail.ratio || ''}
              maxLength={20}
              onChange={(e) => handleDetailChange(idx, "ratio", e.target.value)}
              placeholder="Enter Ratio"
            />
          </label>

          <label>VA/PH
            <input
              type="text"
              value={detail.vaPh || ''}
              maxLength={20}
              onChange={(e) => handleDetailChange(idx, "vaPh", e.target.value)}
              placeholder="Enter VA/PH"
            />
          </label>

          <label>Class
            <select
              value={detail.class || ''}
              onChange={(e) => handleDetailChange(idx, "class", e.target.value)}>
              <option value="">Select Class</option>
              {kneePointTypes.map(k => <option key={k} value={k}>{k}</option>)}
            </select>
          </label>

          <label>Volts
            <input
              type="text"
              value={detail.volts || ''}
              maxLength={20}
              onChange={(e) => handleDetailChange(idx, "volts", e.target.value)}
              placeholder="Enter Volts"
            />
          </label>
        </fieldset>
      ))}

      <div className="button-group">
        <button type="button" onClick={goBack}>Back</button>
        <button type="button" className="nxt1" onClick={handleNext}>Next</button>
      </div>
    </div>
  );

  const renderPage = () => {
    switch (currentPage) {
      case "home": return renderHomePage();
      case "insulation": return <VTInsulation goBack={handleBack} goToNext={() => setCurrentPage("checking")} formData={allFormData} updateFormData={(data) => updateFormData("insulationData", data)} />;
      case "checking": return <VTChecking goBack={handleBack} goToNext={() => setCurrentPage("ratio")} formData={allFormData} updateResistance={(data) => updateFormData("windingResistance", data)} updatePolarity={(data) => updateFormData("polarityCheck", data)} />;
      case "ratio": return <VTRatio goBack={handleBack} goToNext={() => setCurrentPage("checklist")} formData={allFormData} updateRatioData={(data) => updateFormData("ratioTestData", data)} />;
      case "checklist": return <VTList goBack={handleBack} updateChecklist={(data) => updateFormData("checklistData", data)} formData={allFormData} />;
      default: return renderHomePage();
    }
  };

  return showBackPage ? <CreateReport goBack={() => setShowBackPage(false)} savedGeneralFormData={allFormData} /> : renderPage();
};

export default VTHome;











